import { configFetch as fetch } from '@laigu/utils';

// 获取默认链接域名
export const getDefaultDomain = () => {
  return fetch({
    url: '/chat_link/default_domain',
    method: 'get'
  });
};

export const getChatLinkStatus = () => {
  return fetch({
    url: '/unified-api/conversations/v1/chatlink_status',
    method: 'get'
  });
};

export const applyChatLink = data => {
  return fetch({
    url: '/unified-api/conversations/v1/chatlink_applications',
    method: 'post',
    data
  });
};

export const applyBlackList = data => {
  return fetch({
    url: '/unified-api/crm/v1/agent/visit/blacklist/application',
    method: 'post',
    data
  });
};
